import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';



interface CardConfig {
  title?: string;
  description?: string;
  background?: 'accented-1';
  classes?: string;
}

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    imports: [
    TranslateModule,
    NgClass
],
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class CardComponent implements OnInit {
  @Input() config: CardConfig;

  cardClasses: string = '';

  constructor() { }

  ngOnInit(): void {
    if (this.config?.classes) {
      this.cardClasses += ` ${this.config?.classes}`;
    }

    if (this.config?.background === 'accented-1') {
      this.cardClasses += ' card-accent-1';
    }
  }

}
